@if (items?.length) {
  <div class="trending-searches">
    <h3 class="trending-searches__heading text-xs fw-500 text-uppercase mb-0">Trending Keywords on AIKosh</h3>

    <ul class="list-unstyled mb-0">
      @for (item of items; track item.keyword) {
        <li
          class="trending-searches__item d-flex align-items-center gap-2 py-2"
          role="button"
          (click)="select.emit(item.keyword)"
        >
          <!-- Trending icon -->
          <img src="images/trending-black-arrow.svg" width="14" height="14" alt="trending"  />

          <!-- Keyword -->
          <span class="trending-searches__keyword text-sm flex-grow-1">{{ item.keyword }}</span>

          <!-- Count — right aligned -->
          <span class="trending-searches__count text-xs text-secondary flex-shrink-0 ms-auto">
            {{ formatCount(item.count) }} Searches
          </span>
        </li>
      }
    </ul>
  </div>
}
